import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dialog-custom__footer" }
const _hoisted_2 = {
  key: 0,
  class: "app-loader app-loader--contextual"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dialogStepComponent), {
      plant: _ctx.plant,
      plantId: _ctx.plantId,
      onIsLoading: _ctx.handleStepLoading,
      onNextEnabled: _ctx.handleNextEnabledChange
    }, null, 8, ["plant", "plantId", "onIsLoading", "onNextEnabled"])),
    _createVNode("footer", _hoisted_1, [
      (_ctx.isBackButtonVisible)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            onClick: _ctx.handleStepBack,
            label: _ctx.$t('AppResource.Back'),
            class: "p-button-text mr-3"
          }, null, 8, ["onClick", "label"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Button, {
        onClick: _ctx.handleButtonSubmitAction,
        label: _ctx.buttonSubmitLabel,
        disabled: 
                !_ctx.nextEnabled ||
                (_ctx.dialogStep === 2 && _ctx.plant.mxServer?.model == undefined)
            ,
        class: "p-button-rounded p-button-raised p-button--m"
      }, null, 8, ["onClick", "label", "disabled"])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_ProgressSpinner)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}